import React, { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { Ico55 } from './Icones55';
import './barre-icones.css';

// LOT 60 · B4 · le nom d'un mot sous l'icône des raccourcis « Aujourd'hui »
const PETITS = new Set(['en', 'à', 'a', 'le', 'la', 'les', 'de', 'du', 'des', 'un', 'une', 'au', 'aux', 'par', 'sur', 'mes', 'vos', 'nos']);
const motCourt = (l) => { const m = String(l || '').replace(/^[+\s]+/, '').split(/[\s·,']+/).find((w) => w && !PETITS.has(w.toLowerCase())) || ''; return m.charAt(0).toUpperCase() + m.slice(1); };

/* LOT 55 · G1 · une action de section = une icône carrée de 40 px ; son nom à l'appui long (téléphone), écrit à côté sur ordinateur */
export const BoutonIcone = ({ ico, logo, label, onClick, badge, testId, actif = false, disabled = false }) => {
  const [tip, setTip] = useState(false);
  const t = useRef(null);
  const long = useRef(false);
  const debut = () => { long.current = false; t.current = setTimeout(() => { long.current = true; setTip(true); }, 450); };
  const fin = () => { clearTimeout(t.current); if (long.current) setTimeout(() => setTip(false), 1200); };
  useEffect(() => () => clearTimeout(t.current), []);
  return (
    <button type="button" className={`bi55${actif ? ' is-actif' : ''}`} aria-label={label} title={label} disabled={disabled}
      onPointerDown={debut} onPointerUp={fin} onPointerLeave={fin} onContextMenu={(e) => e.preventDefault()}
      onClick={(e) => { if (long.current) { e.preventDefault(); long.current = false; return; } onClick?.(e); }} data-testid={testId} data-keepicon="">
      {logo || <Ico55 k={ico} size={20} />}<span className="bi55-l">{label}</span><span className="bi55-c" aria-hidden="true">{motCourt(label)}</span>
      {badge > 0 && <em className="bi55-n" data-testid={`${testId}-pastille`}>{badge}</em>}
      {tip && <span className="bi55-tip" role="tooltip" data-testid={`${testId}-nom`}>{label}</span>}
    </button>
  );
};

export const BarreIcones = ({ children, testId, className = '' }) => <div className={`bi55-barre ${className}`} data-testid={testId}>{children}</div>;

/* L'action principale de la page (jaune, un mot) : dans la barre du haut sur téléphone, qui reste visible au défilement */
let principale = null;
const abonnes = new Set();
const publier = (p) => { principale = p; abonnes.forEach((f) => f()); };
const abonner = (f) => { abonnes.add(f); return () => abonnes.delete(f); };
export const usePrincipale = () => useSyncExternalStore(abonner, () => principale);

const estTel = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
export const useTel = () => { const [m, setM] = useState(estTel()); useEffect(() => { const q = window.matchMedia('(max-width: 767px)'); const f = () => setM(q.matches); q.addEventListener('change', f); return () => q.removeEventListener('change', f); }, []); return m; };

export const ActionPrincipale = ({ label, onClick, testId }) => {
  const tel = useTel();
  const ref = useRef(onClick); ref.current = onClick;
  useEffect(() => {
    if (!tel) return undefined;
    const p = { label, testId, onClick: (...a) => ref.current?.(...a) };
    publier(p);
    return () => { if (principale === p) publier(null); };
  }, [tel, label, testId]);
  if (tel) return null;
  return <button type="button" className="bi55-jaune" onClick={onClick} data-testid={testId} data-keepicon=""><Ico55 k="plus" size={18} />{label}</button>;
};

export const PrincipaleHaut = () => {
  const p = usePrincipale();
  if (!p) return null;
  return <button type="button" className="bi55-jaune is-haut" onClick={p.onClick} data-testid={p.testId} data-keepicon=""><Ico55 k="plus" size={18} />{p.label}</button>;
};
